import { useState } from "react";

// One-line "what helped" note for a saved guide
export const GuideNoteEditor = ({ initial = "", onSave, onCancel, testPrefix, autoFocus = true }) => {
  const [text, setText] = useState(initial);
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await onSave(text.trim());
    setBusy(false);
    if (ok) onCancel?.();
  };
  return (
    <form onSubmit={save} className="flex flex-col sm:flex-row gap-2 w-full" data-testid={`${testPrefix}-form`}>
      <input className="mm-input !py-2 text-sm flex-1" maxLength={140} autoFocus={autoFocus} placeholder="What helped? e.g. the 3am notebook trick"
        value={text} onChange={(e) => setText(e.target.value)} data-testid={`${testPrefix}-input`} />
      <div className="flex gap-2 items-center">
        <span className="text-xs text-mm-muted w-12 text-right">{text.length}/140</span>
        <button className="mm-btn !py-2 !px-4 text-sm" disabled={busy} data-testid={`${testPrefix}-save`}>Save</button>
        {onCancel && <button type="button" className="mm-btn-ghost !py-2 !px-3 text-sm" onClick={onCancel} data-testid={`${testPrefix}-cancel`}>Cancel</button>}
      </div>
    </form>
  );
};
